<template>
  <div class="select-wrapper">
    <div class="select-area">
      <el-select
        v-model="localValue"
        multiple
        collapse-tags
        clearable
        style="width: 100%;"
        placeholder="请选择"
        @change="companyChanged"
      >
        <el-option value="ALL" class="all-check-option">
          <el-checkbox
            v-model="checkAll"
            @change="handleCheckAllChange"
            :indeterminate="isIndeterminate"
          >全选</el-checkbox>
        </el-option>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="info-area">
      <div class="title">多选下拉框</div>
      <div class="current-value" v-if="localValue && localValue.length > 0">
        <span class="label">绑定值:</span>
        <span class="value">{{ localValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiSelect',
  data() {
    return {
      localValue: [],
      options: [
        { value: '1', label: '选项1' },
        { value: '2', label: '选项2' },
        { value: '3', label: '选项3' },
        { value: '4', label: '选项4' },
      ],
      checkAll: false,
      isIndeterminate: false,
    }
  },
  methods: {
    companyChanged(val) {
      const realVal = val.filter(v => v !== 'ALL');
      if (val.includes('ALL')) {
        this.localValue = realVal;
      }
      const checkedCount = realVal.length;
      this.checkAll = checkedCount === this.options.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
    },
    handleCheckAllChange(val) {
      const allValues = this.options.map(item => item.value);
      this.localValue = val ? allValues : [];
      this.isIndeterminate = false;
    }
  }
}
</script>

<style scoped>
.select-wrapper {
  text-align: center;
}
.select-area {
  margin-bottom: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-area {
  text-align: left;
  padding-top: 15px;
}
.title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}
.current-value {
  font-size: 12px;
  color: #606266;
  background: var(--surface-2);
  padding: 8px;
  border-radius: 3px;
  word-break: break-all;
  line-height: 1.4;
}
.current-value .label {
  font-weight: bold;
  color: #409EFF;
  margin-right: 5px;
}
</style>
